import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { IExecution } from '../types/IExecution';

/**
 * Parameters for the VizPortal `listExecutions` Web Client method
 * (WebClientContentMobilityAppService.listExecutions): the calling user's executions of one plan, newest
 * first, offset-paged. `offset` maps to the service's `start_index`; `pageSize` defaults to 50, max 100.
 */
export interface IListExecutionsParams {
  planLuid: string;
  pageSize?: number;
  offset?: number;
}

export interface IListExecutionsResult extends IGetItemsResult {
  executions?: IExecution[];
}

export class ListExecutionsRequest extends Request<IListExecutionsParams, IListExecutionsResult> {
  constructor(params: IListExecutionsParams) {
    super('listExecutions', params);
  }
}
